type CheckoutRedirectParams = {
  from?: string | null;
  planId?: string | null;
};

export function getCheckoutRedirectPath(
  token?: string | null,
  redirectParams?: CheckoutRedirectParams
): string {
  const params = new URLSearchParams();
  if (token) params.set("token", token);
  if (redirectParams?.from) params.set("from", redirectParams.from);
  if (redirectParams?.planId) params.set("plan_id", redirectParams.planId);
  const query = params.toString();
  if (!query) return "/checkout";

  return `/checkout?${params.toString()}`;
}

export function getPostAuthRedirectPath(
  intent?: string,
  token?: string,
  redirectParams?: CheckoutRedirectParams
): string {
  if (!intent) return "/";
  if (intent === "checkout")
    return getCheckoutRedirectPath(token, redirectParams);
  if (intent === "accept_invite" && token !== undefined) {
    return `/invite/${token}`;
  }
  if (intent === "accept_gift_invite" && token !== undefined) {
    return `/invite/gift/${token}`;
  }
  return intent;
}

export function getAanmeldenAuthenticatedRedirectPath({
  isLoggedIn,
  intent,
  token,
  from,
  planId
}: {
  isLoggedIn: boolean | null;
  intent?: string | null;
  token?: string | null;
  from?: string | null;
  planId?: string | null;
}): string | null {
  if (isLoggedIn !== true) return null;
  if (intent === "checkout")
    return getCheckoutRedirectPath(token, { from, planId });
  if (!intent) return "/";
  return null;
}

// Trial buttons open the plan page as a focused checkout: /abonnement?start=proefweek shows no topbar (Louis 23 sep).
// The "Abonnement" menu item opens plain /abonnement with the topbar.
export const TRIAL_START_QUERY = "start=proefweek";

// `native` means "login checkout": the app, or the login-checkout variant of abonnement-email-checkout-v1.
export function getTrialSignupTarget(
  isLoggedIn: boolean | null,
  native = false
): string {
  if (isLoggedIn === true) return "/checkout";
  return native ? "/aanmelden?intent=checkout" : `/abonnement?${TRIAL_START_QUERY}`;
}

export function getSubscriptionCtaTarget({ isLoggedIn, parentRegistration, native = false }: {
  isLoggedIn: boolean | null; parentRegistration?: boolean; native?: boolean;
}): string {
  if (native && parentRegistration && isLoggedIn !== true) return "/aanmelden?intent=checkout&source=ouders";
  return getTrialSignupTarget(isLoggedIn, native);
}

export function getOAuthStateToken(
  intent?: string | null,
  token?: string | null
): string | undefined {
  if (
    intent === "accept_invite" ||
    intent === "accept_gift_invite" ||
    intent === "checkout"
  ) {
    return token ?? undefined;
  }
  return undefined;
}

// Restart OAuth without losing the destination that required authentication.
export function getAuthRetryPath(
  intent?: string,
  token?: string,
  role?: string,
  redirectParams?: CheckoutRedirectParams
): string {
  const params = new URLSearchParams();
  if (intent) params.set("intent", intent);
  if (token) params.set("token", token);
  if (role) params.set("role", role);
  if (redirectParams?.from) params.set("from", redirectParams.from);
  if (redirectParams?.planId) params.set("plan_id", redirectParams.planId);
  const query = params.toString();
  return query ? `/aanmelden?${query}` : "/aanmelden";
}
